<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout column>
        <v-flex>
          <v-layout row wrap>
            <v-flex>
              <v-card raised>
                <v-card-title class="title">
                  Device Profile
                </v-card-title>
                <v-card-text align=left>
                  <v-layout row>
                    <v-flex text-xs-left>{{ showCareGrupAndUser() }}</v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row>
            <v-flex>
              <v-card color="transparent">
                <v-card-title class="subheading">Device Info</v-card-title>
                <v-divider></v-divider>
                <v-card-text align="left">
                  <v-layout row>
                    <v-flex>
                      <v-text-field readonly label="Device ID" v-model="device.deviceId"></v-text-field>
                    </v-flex>
                    <v-flex>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field readonly label="Made" v-model="device.made"></v-text-field>
                    </v-flex>
                    <v-flex v-if="shouldDisplay('/deviceUpdate')">
                      <v-dialog v-model="dialog1">
                        <v-btn small icon slot="activator"><v-icon color="grey">edit</v-icon></v-btn>
                        <v-form v-model="valid">
                          <v-card>
                            <v-card-text>
                              <v-text-field
                                v-model="madeUpdate"
                                label="Made"
                                type="text"
                                hint="Please enter device made here"
                                :counter="45"
                                :rules="nameRules"
                                required
                              ></v-text-field>
                            </v-card-text>
                            <small>*indicates required field</small>
                            <v-spacer></v-spacer>
                            <v-btn flat color="blue darken-1"
                              @click.native="dialog1 = false">Close</v-btn>
                            <v-btn flat color="blue darken-1"
                            @click="update" :disable="!valid">Save</v-btn>
                          </v-card>
                        </v-form>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field readonly label="Model" v-model="device.model"></v-text-field>
                    </v-flex>
                    <v-flex v-if="shouldDisplay('/deviceUpdate')">
                      <v-dialog v-model="dialog2">
                        <v-btn small icon slot="activator"><v-icon color="grey">edit</v-icon></v-btn>
                        <v-form v-model="valid">
                          <v-card>
                            <v-card-text>
                              <v-text-field
                                v-model="modelUpdate"
                                label="Model"
                                type="text"
                                hint="Please enter device model here"
                                :counter="45"
                                :rules="nameRules"
                                required
                              ></v-text-field>
                            </v-card-text>
                            <small>*indicates required field</small>
                            <v-spacer></v-spacer>
                            <v-btn flat color="blue darken-1"
                              @click.native="dialog2 = false">Close</v-btn>
                            <v-btn flat color="blue darken-1"
                              @click="update" :disabled="!valid">Save</v-btn>
                          </v-card>
                        </v-form>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field readonly label="Serial" v-model="device.serial"></v-text-field>
                    </v-flex>
                    <v-flex v-if="shouldDisplay('/deviceUpdate')">
                      <v-dialog v-model="dialog3">
                        <v-btn small icon slot="activator"><v-icon color="grey">edit</v-icon></v-btn>
                        <v-form v-model="valid">
                          <v-card>
                            <v-card-text>
                              <v-text-field
                                v-model="serialUpdate"
                                label="Serial"
                                type="text"
                                hint="Please enter device serial here"
                                :counter="45"
                                :rules="nameRules"
                                required
                              ></v-text-field>
                            </v-card-text>
                            <small>*indicates required field</small>
                            <v-spacer></v-spacer>
                            <v-btn flat color="blue darken-1"
                              @click.native="dialog3 = false">Close</v-btn>
                            <v-btn flat color="blue darken-1"
                              @click="update" :disabled="!valid">Save</v-btn>
                          </v-card>
                        </v-form>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <div class="red white--text subheading">{{ errMsg }}</div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import mixins from '@/mixins.js'
  import DeviceService from '@/services/DeviceService'

  export default {
    data () {
      return {
        name: this.$route.params.name,
        dialog1: false,
        dialog2: false,
        dialog3: false,
        valid: false,

        nameRules: [
          (v) => !!v || 'This field is required',
          (v) => v.length <= 45 || 'This field must be less than 45 characters'
        ],
        errMsg: '',
        madeUpdate: '',
        modelUpdate: '',
        serialUpdate: '',

        device: {
          deviceId: '',
          made: '',
          model: '',
          serial: '',
          stateType: {
            description: ''
          },
          careGroup: {
            name: ''
          }
        }
      }
    },
    methods: {
      async update() {
        this.dialog1 = false
        this.dialog2 = false
        this.dialog3 = false
        try {
          const response = await DeviceService.update({
            deviceRecordId: this.deviceRecordId,
            made: this.madeUpdate,
            model: this.modelUpdate,
            serial: this.serialUpdate,
            state: this.state
          })
          this.errMsg = "Update Successful"
          this.device.made = this.madeUpdate
          this.device.model = this.modelUpdate
          this.device.serial = this.serialUpdate
        } catch (error) {
          this.errMsg = this.handleError(error)
        }
      },
      showCareGrupAndUser: function() {
        if (this.device.careGroup) {
          if (this.device.careUser) {
            return 'This Device is under to Care Group ' + this.device.careGroup.name + ' and Care User ' + this.device.careUser.firstName + ' ' + this.device.careUser.lastName
          } else {
            return 'This Device is under to Care Group ' + this.device.careGroup.name + ' without any Care User assigned'
          }
        }
        else {
          return 'This Device is not assigned to any Care Group'
        }
      },
    },
    mixins: [mixins],
    async mounted () {
      try {
        this.dialog1 = false
        this.dialog2 = false
        this.dialog3 = false
        this.errMsg = ''
        const deviceRecordId = this.$route.params.id
        this.device= (await DeviceService.show({deviceRecordId})).data
        this.deviceId = this.device.deviceId
        this.madeUpdate = this.device.made
        this.modelUpdate = this.device.model
        this.serialUpdate = this.device.serial
        this.deviceRecordId = this.device.deviceRecordId
        this.state = this.device.state
      } catch (error) {
        this.errMsg = this.handleError(error)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Device/DeviceTabProfile.vue